export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10249.d739cb81.jpg";